"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsentManager = void 0;
const feature_hub_utils_1 = require("@volkswagen-onehub/feature-hub-utils");
/**
 * Channel of communication between the consent management integrated into the integrator and the feature service.
 */
class ConsentManager extends feature_hub_utils_1.Subscribable {
    /**
     * @param getConsent function that returns the current consent given by the user
     */
    constructor(getConsent) {
        super();
        this.getConsent = getConsent;
    }
    /**
     * Returns the current user consent. Will call the `getConsent` function supplied to the constructor every time.
     */
    get currentConsent() {
        return this.getConsent();
    }
    /**
     * Update the consent given by the user. This will trigger the automatic deletion of cookies for which there no
     * longer is any consent in the cookie service. Should be called by the integrator when the user consent changes.
     *
     * The `newConsent`will not be saved within this ConsentManager, so make sure to only call this function after the
     * `getConsent` function supplied to the constructor also returns the new consent state to prevent an inconsistent
     * state.
     *
     * @param newConsent the updated state of the user consent. If not given, `this.currentConsent` will be used.
     */
    update(newConsent) {
        this.updateInternal(newConsent || this.currentConsent);
    }
}
exports.ConsentManager = ConsentManager;
//# sourceMappingURL=consent-manager.js.map